import { useEffect, useState } from 'react';
import Card from '../components/card/Card';
import Icon from '../components/icon/Icon';
import Label from '../components/texts/label/Label';
import Button from '../components/button/Button';
import { useNavigate } from 'react-router-dom';
import { ROLES } from '../utils/Constants';
import { routes } from '../routes/routePaths';
import { useClientLogo } from '../hooks/useClientLogo';

const NavBar: React.FC = () => {
  const name = localStorage.getItem('full_name');
  const role = localStorage.getItem('roles');
  const [currentRole, setCurrentRole] = useState('');
  const userLetter = name?.substring(0, 2).toUpperCase();
  const navigate = useNavigate();
  const { logoUrl, isLoading: logoLoading } = useClientLogo();

  useEffect(() => {
    if (role) {
      const roleMap: { [key: string]: string } = {
        PRODUCTOR: ROLES.producer,
        COMITE: ROLES.comite,
        INSTRUMENTADOR: ROLES.instrumentator,
      };
      const roleFound = Object.keys(roleMap).find((key) => role.includes(key));
      setCurrentRole(roleFound ? roleMap[roleFound] : ROLES.commercial);
    }
  }, [role]);

  const logout = () => {
    localStorage.clear();
    navigate(routes.login);
  };

  return (
    <Card
      width='-webkit-fill-available'
      maxWidth='100vw'
      variant='neutral'
      spacing={{ top: '2', right: '3', bottom: '2', left: '3' }}
      borderRadius={false}
      modifier='inverted'
      display='flex'
      justifyContent='space-between'
    >
      <Card
        display='flex'
        alignItems='center'
        gap='16px'
        onClick={() => navigate(routes.dashboard)}
      >
        {logoUrl ? (
          <>
            <img 
              src={logoUrl} 
              alt="Logo" 
              style={{ height: '39px', width: 'auto' }} 
            />
          </>
        ) : (
          <>
            <Icon height={39} name='isotipo' width={39} />
            <Icon name='logo' variant='secondary-1' modifier='strong' width={80} />
          </>
        )}
      </Card>
      <Card display='flex' gap='16px' style={{ minWidth: 0, flexShrink: 1 }}>
        <Card width='1px' variant='success'></Card>
        <Card
          border={true}
          variant='info'
          spacing={'2'}
          modifier='inverted'
          display='flex'
          alignItems='center'
          borderRadiusAmount='5'
        >
          <Label weight='bold' type='1'>
            {userLetter}
          </Label>
        </Card>
        <Card
          display='grid'
          spacing={{ top: '0', right: '3' }}
          alignItems='center'
          style={{ minWidth: 0, maxWidth: '180px', overflow: 'hidden' }}
        >
          <Label type='4'>{currentRole}</Label>
          <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            <Label type='2' weight='bold'>
              {name}
            </Label>
          </div>
        </Card>
        <Button variant='secondary' size='sm' onClick={logout}>
          Cerrar sesión
        </Button>
      </Card>
    </Card>
  );
};

export default NavBar;
